const serviceRoot = 'api/nonPcn/';

export const NonPcnEndpoints = {
  addNonPcn: () => `${serviceRoot}addNonPcn`,
  updateNonPcn: () => `${serviceRoot}updateNonPcn`,
  getNonPcn: () => `${serviceRoot}getNonPcn`,
};
